/**
 * Platform Helper
 * 
 * Central platform management helper functions.
 * To add a new platform, only update this file.
 */

export type PlatformType = "inn-tech" | "betora";

const HOSTNAME = window?.location?.hostname || "";

/**
 * Returns the current platform
 */
export const getPlatform = (): PlatformType => {
  if (HOSTNAME.includes("betora")) return "betora";
  if (HOSTNAME.includes("inntech.ae")) return "inn-tech";
  return "inn-tech"; // default
};

/**
 * Current platform value (constant)
 */
export const PLATFORM = getPlatform();

/**
 * Platform control functions
 */
export const isInnTech = (): boolean => PLATFORM === "inn-tech";
export const isBetora = (): boolean => PLATFORM === "betora";

/**
 * Returns the platform based value
 */
export const getPlatformValue = <T>(values: { innTech: T; betora: T }): T => {
  return isBetora() ? values.betora : values.innTech;
};
